import Vue from 'vue';

type ComponentDefinition = Parameters<typeof Vue.component>[1];
type ComponentRegistry = Record<string, ComponentDefinition>;
type VueRuntime = typeof Vue & {
    options?: {
        components?: Record<string, unknown>;
    };
};

/**
 * 依照指定名稱註冊元件，避免重複覆寫已存在的全域元件
 */
export const registerRuntimeComponents = (
    componentRegistry: ComponentRegistry
): void => {
    const vueRuntime = Vue as VueRuntime;

    Object.entries(componentRegistry).forEach(
        ([componentName, componentDefinition]) => {
            if (vueRuntime.options?.components?.[componentName]) {
                return;
            }

            Vue.component(componentName, componentDefinition);
        }
    );
};
